<fdx-common-core></fdx-common-core>
<app-progress-bar></app-progress-bar>
<app-main-page></app-main-page>
<app-create-shipment-page></app-create-shipment-page>
<app-shipping-options-page></app-shipping-options-page>
<app-courier-shipping-confirmation-page></app-courier-shipping-confirmation-page>
<app-pickup-confirmation-page></app-pickup-confirmation-page>
<app-point-shipping-confirmation-page></app-point-shipping-confirmation-page>
<router-outlet></router-outlet>
<app-captcha-dialog></app-captcha-dialog>
